import type { VariantProps } from 'class-variance-authority'

import { Button as ButtonPrimitive } from '@base-ui/react/button'
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const buttonVariants = cva(
    'group/button inline-flex shrink-0 items-center justify-center gap-2 rounded-lg border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:ring-3 focus-visible:ring-ring/25 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*="size-"])]:size-4',
    {
        variants: {
            variant: {
                default: 'bg-primary text-primary-foreground hover:bg-primary/85',
                outline: 'border-border bg-card text-foreground hover:bg-muted aria-expanded:bg-muted',
                secondary: 'bg-secondary text-secondary-foreground hover:bg-[color-mix(in_oklch,var(--secondary),var(--foreground)_6%)] aria-expanded:bg-secondary',
                ghost: 'text-foreground hover:bg-muted aria-expanded:bg-muted',
                destructive: 'bg-destructive/10 text-destructive hover:bg-destructive/15 focus-visible:ring-destructive/20',
                link: 'h-auto px-0 text-foreground underline-offset-4 hover:underline'
            },
            size: {
                default: 'h-10 px-4',
                xs: 'h-7 gap-1 rounded-md px-2.5 text-xs [&_svg:not([class*="size-"])]:size-3.5',
                sm: 'h-8 gap-1.5 rounded-md px-3 text-[13px]',
                lg: 'h-12 px-6 text-[15px]',
                icon: 'size-10',
                'icon-xs': 'size-7 rounded-md [&_svg:not([class*="size-"])]:size-3.5',
                'icon-sm': 'size-8 rounded-md',
                'icon-lg': 'size-12'
            }
        },
        defaultVariants: {
            variant: 'default',
            size: 'default'
        }
    }
)

function Button({
    className,
    variant = 'default',
    size = 'default',
    ...props
}: ButtonPrimitive.Props & VariantProps<typeof buttonVariants>) {
    return (
        <ButtonPrimitive
            data-slot='button'
            className={cn(buttonVariants({ variant, size, className }))}
            {...props}
        />
    )
}

export { Button, buttonVariants }
